/**
 * Single editable content surface for site-wide facts.
 *
 * Anything marked TODO is a placeholder the client needs to confirm — it is
 * deliberately obvious rather than quietly invented.
 */

export const site = {
  name: 'Falcon Solutions',
  legalName: 'Falcon Solutions Private Limited',
  domain: 'falcon-sol.com',
  tagline: 'Where Falcon Vision Meets Smart Solutions',

  email: {
    general: 'info@falcon-sol.com',
    careers: 'careers@falcon-sol.com',
  },

  /**
   * Cal.com booking. The company account, so it survives staff changes.
   *
   * This is the only place the booking URL appears — swapping accounts or
   * event types is a one-line change here.
   */
  booking: {
    link: 'falcon-solutions-wqu1gj',
    label: 'Schedule a call',
  },

  /**
   * Two locations, client-confirmed. No phone number and no street address by
   * choice — email and socials are the contact channels.
   */
  locations: [
    { city: 'Calgary', region: 'Alberta', country: 'Canada', timezone: 'MST' },
    { city: 'Lahore', region: 'Johar Town', country: 'Pakistan', timezone: 'PKT' },
  ],

  /**
   * Canonical social URLs. The rendered icon row (with per-platform brand
   * colours) lives in src/components/icons/social.tsx — keep the two in sync.
   */
  social: {
    linkedin: 'https://www.linkedin.com/company/falcon-sol-pvt-ltd',
    facebook: 'https://www.facebook.com/falconsolutions.official',
    instagram: 'https://www.instagram.com/falconsolutions.official',
    threads: 'https://www.threads.net/@falconsolutions.official',
  },

  nav: [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/services' },
    { label: 'Portfolio', href: '/portfolio' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'About', href: '/about' },
    { label: 'Careers', href: '/careers' },
    { label: 'Contact', href: '/contact' },
  ],
} as const;

export type Site = typeof site;

/**
 * One office. Named SiteLocation rather than Location because `Location` is a
 * DOM global and shadowing it in a component file is a trap.
 */
export interface SiteLocation {
  city: string;
  region: string;
  country: string;
  timezone: string;
}
